import React, { Component } from "react";
import { Tabs } from "react-bootstrap";
import { Tab } from "react-bootstrap";
import { Col } from "reactstrap";
import { Card } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { Breadcrumb } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

class PartnerLoginDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      partnerData: [""],
      partnerId: (this.props.location && this.props.location.data && this.props.location.data.id) ? this.props.location.data.id : (this.props.location.state && this.props.location.state.data && this.props.location.state.data.id) ? this.props.location.state.data.id : ''
    };
    this.nextPath = this.nextPath.bind(this);
  }

  nextPath = (path, value) => {
    console.log(value)
    this.props.history.push({ pathname: path, data: value, state: {data: this.state} });
    console.log(this.props.history)
  }

  componentDidMount() {
    let userId = this.props.userId;
    let userRole = this.props.userRole; 
    const url = process.env.REACT_APP_NODE_ENV + "/api/partners/getPartnerIdByUser/" + userId
    fetch(url,{
      method:'GET',
      headers: {
      'Content-Type': 'application/json',
      'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
    }
    }).then(
      response => { return response.json(); }
    ).then(data => {
      this.setState({ partnerData: data[0] })
    })
  }

  render() {

    return (<>

      <Breadcrumb>
        <Breadcrumb.Item active>Partner Details</Breadcrumb.Item>
      </Breadcrumb>
      <div>
        <Card>
          <Card.Body>
            <Card.Title style={{ fontWeight: "bold", fontSize: "20px" }}>
              Partner Details - {this.state.partnerData.partnerFirmName}
              <Button className="float-right"
                variant="outline-success"
                style={{ marginTop: "25px", width: "150px" }}
                onClick={() => this.nextPath("/partner/partner-edit", this.state.partnerData)}>
                Edit
                  </Button>
            </Card.Title>
            <br />
            <br />
            <Tabs defaultActiveKey="basic-details">
              <Tab eventKey="basic-details" title="Basic">
                <Form>
                  <Form.Row>
                    <Form.Group as={Col}>
                      <Form.Label> Firm Name:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.partnerData.partnerFirmName} disabled
                      ></Form.Control>
                    </Form.Group>
                    <Form.Group as={Col}>
                      <Form.Label> Phone Number:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.partnerData.phoneNumber} disabled
                      ></Form.Control>
                    </Form.Group>
                    <Form.Group as={Col}>
                      <Form.Label> Address:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.partnerData.addressLine1 + "," + this.state.partnerData.addressLine2} disabled
                      ></Form.Control>
                    </Form.Group>
                  </Form.Row>

                  <Form.Row>
                    <Form.Group as={Col}>
                      <Form.Label> City:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.partnerData.city} disabled
                      ></Form.Control>
                    </Form.Group>
                    <Form.Group as={Col}>
                      <Form.Label> State</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.partnerData.state} disabled
                      ></Form.Control>
                    </Form.Group>
                    <Form.Group as={Col}>
                      <Form.Label> Pincode:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.partnerData.pincode} disabled
                      ></Form.Control>
                    </Form.Group>
                  </Form.Row>
                </Form>
              </Tab>

              <Tab eventKey="business-details" title="Business">
                <Form>
                  <Form.Row>
                    <Form.Group as={Col}>
                      <Form.Label> Business License Number:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.partnerData.businessLicenseNumber} disabled
                      ></Form.Control>
                    </Form.Group>
                    <Form.Group as={Col}>
                      <Form.Label> GST Number:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.partnerData.gstNumber} disabled
                      ></Form.Control>
                    </Form.Group>
                    <Form.Group as={Col}>
                      <Form.Label> Pan Number:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.partnerData.panNumber} disabled
                      ></Form.Control>
                    </Form.Group>
                  </Form.Row>

                  <Form.Row>
                    <Form.Group as={Col}>
                      <Form.Label> Partner Type:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.partnerData.partnerType} disabled
                      ></Form.Control>
                    </Form.Group>
                    <Form.Group as={Col}>
                      <Form.Label> Number of Vehicles</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.partnerData.numberOfVechiles} disabled
                      ></Form.Control>
                    </Form.Group>
                    <Form.Group as={Col}>
                      <Form.Label> Number of Borewells:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.partnerData.numberOfBorewells} disabled
                      ></Form.Control>
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group className="col-lg-4" as={Col}>
                      <Form.Label> Partner Catagory:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.partnerData.partnerCatagory} disabled
                      ></Form.Control>
                    </Form.Group>
                  </Form.Row>
                </Form>
              </Tab>
              <Tab eventKey="poc" title="POC">
                <Form>
                  <Form.Row>
                    <Form.Group as={Col}>
                      <Form.Label> Contact Person:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.partnerData.contactPerson1Name} disabled
                      ></Form.Control>
                    </Form.Group>
                    <Form.Group as={Col}>
                      <Form.Label> Phone Number:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.partnerData.contactPerson1Number} disabled
                      ></Form.Control>
                    </Form.Group>
                    <Form.Group as={Col}>
                      <Form.Label> Email ID:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.partnerData.contactPerson1Email} disabled
                      ></Form.Control>
                    </Form.Group>
                  </Form.Row>
                </Form>
              </Tab>
              <Tab eventKey="bank-details" title="Bank">
                <Form>
                  <Form.Row>
                    <Form.Group as={Col}>
                      <Form.Label> Bank Name:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.partnerData.bankName} disabled
                      ></Form.Control>
                    </Form.Group>
                    <Form.Group as={Col}>
                      <Form.Label> Account Number:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.partnerData.accountNumber} disabled
                      ></Form.Control>
                    </Form.Group>
                  </Form.Row>

                  <Form.Row>
                    <Form.Group as={Col}>
                      <Form.Label> IFSC Code:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.partnerData.ifscCode} disabled
                      ></Form.Control>
                    </Form.Group>

                    <Form.Group as={Col}>
                      <Form.Label> Account Holder Name:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.partnerData.acHolderName} disabled
                      ></Form.Control>
                    </Form.Group>
                  </Form.Row>
                </Form>
              </Tab>
              <Tab eventKey="payment-details" title="Payment">
                <Form>
                  <Form.Row>
                    <Form.Group as={Col}>
                      <Form.Label> Payment Clearance Limit:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.partnerData.paymentClearanceLimit} disabled
                      ></Form.Control>
                    </Form.Group>
                    <Form.Group as={Col}>
                      <Form.Label> Payment Clearance Frequency:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.partnerData.paymentClearanceFrequency} disabled
                      ></Form.Control>
                    </Form.Group>
                  </Form.Row>

                  <Form.Row>
                    <Form.Group as={Col}>
                      <Form.Label> Payment Pending :</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.partnerData.paymentPending} disabled
                      ></Form.Control>
                    </Form.Group>

                    <Form.Group as={Col}>
                      <Form.Label> Payment Pending Due by:</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.partnerData.paymentPendingDueBy} disabled
                      ></Form.Control>
                    </Form.Group>
                  </Form.Row>
                </Form>
              </Tab>
            </Tabs>
          </Card.Body>
        </Card>
      </div>
    </>
    );
  }
}

const mapStateToProps = (state /*, ownProps*/) => {
    return {
      userRole: state.auth.user[0].userType,
      userId: state.auth.user[0].id 
    }
  }
  
  export default connect(
    mapStateToProps,
    null
  )(withRouter(PartnerLoginDetail))


